import { FormInstance, message, Modal} from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { contractService } from '../../../services/contractService';

interface DetailHandlersProps {
  id: string;
  form: FormInstance;
  navigate: NavigateFunction;
}

interface DetailHandlers {
  handleOnClickAddButtonClick: () => Promise<void>;
  handleOnClickEditButtonClick: () => Promise<void>;
  handleOnClickDeleteButtonClick: (id: number) => Promise<void>;
}

const detailHandlers = ({ id, form, navigate }: DetailHandlersProps): DetailHandlers => {
  const handleOnClickAddButtonClick = async (): Promise<void> => {
    try {
      // Form validation - throws error here if validation fails
      await form.validateFields();

      // Show loading message after validation passes
      const loadingMessage = message.loading('Creating...', 0);

      const contract = form.getFieldsValue();
      // Remove null/undefined/empty string values from all fields except licensor
      Object.keys(contract).forEach(key => {
        if (
          key !== 'licensor' &&
          (contract[key] === null || contract[key] === undefined || contract[key] === '')
        ) {
          delete contract[key];
        }
      });
      await contractService.create(contract);
      loadingMessage();
      navigate('/contract');
    } catch (error) {
      message.destroy();

      // Validation error case
      if (error && typeof error === 'object' && 'errorFields' in error) {
        Modal.error({ title: 'Error', content: 'Please fill in all required fields.', okText: 'Confirm' });
        return;
      }

      // API error case
      console.error('Failed to create:', error);
    }
  };

  const handleOnClickEditButtonClick = async (): Promise<void> => {
    try {
      // Form validation - throws error here if validation fails
      await form.validateFields();

      // Show loading message after validation passes
      const loadingMessage = message.loading('Updating...', 0);

      const contract = form.getFieldsValue();
      Object.keys(contract).forEach(key => {
        if (
          key !== 'licensor' &&
          (contract[key] === null || contract[key] === undefined || contract[key] === '')
        ) {
          delete contract[key];
        }
      });
      await contractService.update(Number(id), contract);
      loadingMessage();
      navigate('/contract');
    } catch (error) {
      message.destroy();

      // Validation error case
      if (error && typeof error === 'object' && 'errorFields' in error) {
        Modal.error({ title: 'Error', content: 'Please fill in all required fields.', okText: 'Confirm' });
        return;
      }

      // API error case
      console.error('Failed to update:', error);
    }
  };

  const handleOnClickDeleteButtonClick = async (): Promise<void> => {
    message.info('You do not have permission');
    return;
  };

  return {
    handleOnClickAddButtonClick,
    handleOnClickEditButtonClick,
    handleOnClickDeleteButtonClick,
  };
};

export default detailHandlers;
